export const translationFR = {
  translation: {
    navBar: {
      title: {
        calendar: "Choisir les dates",
        accommodation: "Hébergement",
        extras: "Extras",
        summary: "Récapitulatif",
        details: "Détails",
        payment: "Paiement",
        success: "Confirmation",
      },
    },
    cart: {
      title: {
        calendar: "Voir les hébergements",
        accommodation: "Continuer vers les extras",
        extras: "Vérifier votre réservation",
        summary: "Saisir vos informations",
        details: "Passer au paiement",
        payment: "Confirmer et payer",
      },
      selectArrivalDate: "Veuillez sélectionner une date d'arrivée",
      selectDepartureDate: "Veuillez sélectionner une date de départ",
      priceFrom: "À partir de",
    },
    weekDays: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    months: [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ],
    shortMonths: [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Juin",
      "Juil",
      "Août",
      "Sep",
      "Oct",
      "Nov",
      "Déc",
    ],
    accommodation: {
      AMS: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Votre propre Hub privé pour jusqu'à 2 voyageurs avec un lit king-size. Parfait pour les voyageurs en solo, les amis ou les couples qui aiment le confort.",
          description:
            "Votre propre Hub privé pour jusqu'à 2 voyageurs avec un lit king-size. Parfait pour les voyageurs en solo, les amis ou les couples qui aiment le confort.",
          imagePath: "/assets/images/accomodation/hub_AMS/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub est un module en forme de L ",
            },
            { src: "see_the_top_hub.jpg", alt: "Voir le Hub du haut" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "À l'intérieur du Hub du haut",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Voir le Hub du bas" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "À l'intérieur du Hub du bas",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Détendez-vous dans votre lit king-size",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Oui, vous pouvez vous asseoir dans votre lit",
            },
            {
              src: "play_your_music_with_bluetooth.jpg",
              alt: "Diffusez votre musique via Bluetooth",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Allez aux douches avec nos kimonos",
            },
            { src: "men_s_bathroom.jpg", alt: "Salle de bain hommes" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Rafraîchissez-vous sous la douche à effet pluie",
            },
            { src: "women_s_bathroom.jpg", alt: "Salle de bain femmes" },
            {
              src: "hair_&_makeup_area.jpg",
              alt: "Espace coiffure et maquillage",
            },
          ],
        },
        howManyTravellers: {
          title: "Combien de voyageurs ?",
          content:
            "Tous nos espaces sont dotés de lits douillets, d'un éclairage d'ambiance et d'une touche de technologie. La seule question est : quel style de séjour préférez-vous ? <br /><br />Nos Hubs sont parfaits pour les voyageurs en solo, les couples ou les amis qui apprécient l'intimité et une ambiance chaleureuse.<br /><br />Sélectionnez 1 à 4 voyageurs pour voir la modification du prix.",
        },
        addAnotherAccomodation: {
          title: "Ajouter un Hub",
          hub: {
            title: "Hub",
            description:
              "Hub privé avec lit king-size – parfait pour un ou deux voyageurs. ",
          },
        },
      },
      CPH: {
        tags: ["Sauna sur place"],
        hub: {
          title: "Hub",
          excerpt:
            "Votre propre Hub privé pour jusqu'à 2 voyageurs avec un lit king-size. Parfait pour les voyageurs en solo, les amis ou les couples qui aiment le confort.",
          description:
            "Votre propre Hub privé pour jusqu'à 2 voyageurs avec un lit king-size. Parfait pour les voyageurs en solo, les amis ou les couples qui aiment le confort.",
          imagePath: "/assets/images/accomodation/hub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub est un module en forme de L ",
            },
            { src: "see_the_top_hub.jpg", alt: "Voir le Hub du haut" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "À l'intérieur du Hub du haut",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Voir le Hub du bas" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "À l'intérieur du Hub du bas",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Détendez-vous dans votre lit king-size",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Allez aux douches avec nos kimonos",
            },
            { src: "hallway.jpg", alt: "Couloir" },
            { src: "men_s_bathroom.jpg", alt: "Salle de bain hommes" },
            { src: "women_s_bathroom.jpg", alt: "Salle de bain femmes" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Produits Rituals gratuits",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Profitez de notre sauna",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Même taille qu'un Hub, mais avec 2 matelas simples, des couvertures séparées et une cloison. Idéal pour deux personnes souhaitant leur propre espace. ",
          description:
            "Même taille qu'un Hub, mais avec 2 matelas simples, des couvertures séparées et une cloison. Idéal pour deux personnes souhaitant leur propre espace. ",
          imagePath: "/assets/images/accomodation/twinHub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub est un module en forme de L ",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Intérieur du Twin Hub du haut",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Intérieur du Twin Hub du bas",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 matelas simples avec une cloison",
            },
            { src: "men_s_bathroom.jpg", alt: "Salle de bain hommes" },
            { src: "women_s_bathroom.jpg", alt: "Salle de bain femmes" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Produits Rituals gratuits",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Profitez de notre sauna",
            },
          ],
        },
        room: {
          title: "Quad Room",
          excerpt:
            "Besoin de plus d'espace ? La Quad Room peut accueillir jusqu'à 4 personnes. Idéal pour les amis ou les familles. Avec salle de bain privée. ",
          description:
            "Besoin de plus d'espace ? La Quad Room peut accueillir jusqu'à 4 personnes. Idéal pour les amis ou les familles. Avec salle de bain privée. Convient également aux personnes à mobilité réduite. ",
          imagePath: "/assets/images/accomodation/quadRoom_CPH/",
          images: [
            {
              src: "quad_room_with_4_bunk_beds.jpg",
              alt: "Quad Room avec 4 lits superposés",
            },
            {
              src: "quad_room_with_a_double_bed_and_2_bunks.jpg",
              alt: "Quad Room avec un lit double et 2 lits superposés",
            },
            { src: "private_bathroom.jpg", alt: "Salle de bain privée" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Rafraîchissez-vous sous la douche à effet pluie",
            },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Produits Rituals gratuits",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Profitez de notre sauna",
            },
          ],
        },
        howManyTravellers: {
          title: "Combien de voyageurs ?",
          content:
            "Tous nos hébergements offrent des lits confortables, un éclairage d'ambiance et une touche de technologie. Comment préférez-vous séjourner ? <ul className=\"list-disc p-4\"><li>Vous voyagez en solo ou en couple et voulez de l'intimité ? → Optez pour un Hub.</li><li>Vous restez ensemble mais préférez des lits séparés ? → Un Twin Hub est parfait.</li><li>Vous cherchez plus d'espace avec une salle de bain privée ? → Choisissez une Quad Room.</li></ul>Quel que soit votre choix, vous dormirez à merveille.<br />Sélectionnez 1 ou 2 personnes pour voir les tarifs.",
        },
        addAnotherAccomodation: {
          title: "Ajouter un autre hébergement",
          hub: { title: "Hub", description: "Hub privé avec lit king-size. " },
          twinHub: {
            title: "Twin Hub",
            description:
              "Hub privé avec deux lits simples et une cloison – idéal pour les amis.",
          },
          room: {
            title: "Quad Room",
            description:
              "Chambre privée avec lits superposés et salle de bain privée – jusqu'à 4 personnes. ",
          },
        },
      },
      RKV: {
        tags: ["Bain à remous sur place"],
        hub: {
          title: "Hub",
          excerpt:
            "Votre propre Hub privé pour jusqu'à 2 voyageurs avec un lit king-size. Parfait pour les voyageurs en solo, les amis ou les couples qui aiment le confort.",
          description:
            "Votre propre Hub privé pour jusqu'à 2 voyageurs avec un lit king-size. Parfait pour les voyageurs en solo, les amis ou les couples qui aiment le confort.",
          imagePath: "/assets/images/accomodation/hub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub est un module en forme de L ",
            },
            { src: "see_the_top_hub.jpg", alt: "Voir le Hub du haut" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "À l'intérieur du Hub du haut",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Voir le Hub du bas" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "À l'intérieur du Hub du bas",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Détendez-vous dans votre lit king-size",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Oui, vous pouvez vous asseoir dans votre lit",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Allez aux douches avec nos kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Salle de bain femmes" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Produits Rituals gratuits",
            },
            { src: "men_s_bathroom.jpg", alt: "Salle de bain hommes" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Détendez-vous dans notre bain à remous sur le toit",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Même taille qu'un Hub, mais avec 2 matelas simples, des couvertures séparées et une cloison. Idéal pour deux personnes souhaitant leur propre espace. ",
          description:
            "Même taille qu'un Hub, mais avec 2 matelas simples, des couvertures séparées et une cloison. Idéal pour deux personnes souhaitant leur propre espace. ",
          imagePath: "/assets/images/accomodation/twinHub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub est un module en forme de L ",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Intérieur du Twin Hub du haut",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Intérieur du Twin Hub du bas",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 matelas simples avec une cloison",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Allez aux douches avec nos kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Salle de bain femmes" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Produits Rituals gratuits",
            },
            { src: "men_s_bathroom.jpg", alt: "Salle de bain hommes" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Détendez-vous dans notre bain à remous sur le toit",
            },
          ],
        },
        movieHub: {
          title: "Movie Hub",
          excerpt: "Hub privé avec lit king-size et grand écran TV. ",
          description:
            "Cette chambre compacte pour deux personnes dispose d'un lit king-size et d'une grande télévision. Idéal pour binge-watcher directement depuis votre lit. ",
          imagePath: "/assets/images/accomodation/movieHub_RKV/",
          images: [
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Détendez-vous dans votre lit king-size",
            },
            {
              src: "large_tv_for_your_favourite_shows.jpg",
              alt: "Grande télévision pour vos séries préférées",
            },
            { src: "women_s_bathroom.jpg", alt: "Salle de bain femmes" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Produits Rituals gratuits",
            },
            { src: "men_s_bathroom.jpg", alt: "Salle de bain hommes" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Détendez-vous dans notre bain à remous sur le toit",
            },
          ],
        },
        howManyTravellers: {
          title: "Combien de voyageurs ?",
          content:
            "Tous nos hébergements offrent des lits confortables, un éclairage d'ambiance et une touche de technologie. Comment préférez-vous séjourner ? <ul className=\"list-disc p-4\"><li>Vous voyagez en solo ou en couple et voulez de l'intimité ? → Optez pour un Hub.</li><li>Vous restez ensemble mais préférez des lits séparés ? → Un Twin Hub est parfait.</li><li>Vous cherchez une chambre plus traditionnelle avec TV (salle de bain partagée) ? → Choisissez un Movie Hub.</li></ul>Quel que soit votre choix, vous dormirez à merveille.<br />Sélectionnez 1 ou 2 personnes pour voir les tarifs.",
        },
        addAnotherAccomodation: {
          title: "Ajouter un autre hébergement",
          hub: {
            title: "Hub",
            description:
              "Hub privé avec lit king-size – parfait pour un ou deux voyageurs. ",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Hub privé avec 2 lits simples et une cloison – idéal pour les amis. ",
          },
          movieHub: {
            title: "Movie Hub",
            description:
              "Chambre privée compacte avec lit king-size et TV – jusqu'à deux personnes. ",
          },
        },
      },
      RTM: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Votre propre Hub privé pour jusqu'à 2 voyageurs avec un lit king-size. Parfait pour les voyageurs en solo, les amis ou les couples qui aiment le confort.",
          description:
            "Votre propre Hub privé pour jusqu'à 2 voyageurs avec un lit king-size. Parfait pour les voyageurs en solo, les amis ou les couples qui aiment le confort.",
          imagePath: "/assets/images/accomodation/hub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub est un module en forme de L ",
            },
            { src: "see_the_top_hub.jpg", alt: "Voir le Hub du haut" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "À l'intérieur du Hub du haut",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Voir le Hub du bas" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "À l'intérieur du Hub du bas",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Détendez-vous dans votre lit king-size",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Oui, vous pouvez vous asseoir dans votre lit",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Allez aux douches avec nos kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Salle de bain femmes" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Rafraîchissez-vous sous la douche à effet pluie",
            },
            { src: "men_s_bathroom.jpg", alt: "Salle de bain hommes" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Produits Rituals gratuits",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Même taille qu'un Hub, mais avec 2 matelas simples, des couvertures séparées et une cloison. Idéal pour deux personnes souhaitant leur propre espace. ",
          description:
            "Même taille qu'un Hub, mais avec 2 matelas simples, des couvertures séparées et une cloison. Idéal pour deux personnes souhaitant leur propre espace. ",
          imagePath: "/assets/images/accomodation/twinHub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub est un module en forme de L ",
            },
            {
              src: "inside_the_bottom_twin_hub.png",
              alt: "Intérieur du Twin Hub du bas",
            },
            {
              src: "relax_in_your_king_size_bed.png",
              alt: "Détendez-vous dans votre lit king-size",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Allez aux douches avec nos kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Salle de bain femmes" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Rafraîchissez-vous sous la douche à effet pluie",
            },
            { src: "men_s_bathroom.jpg", alt: "Salle de bain hommes" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Produits Rituals gratuits",
            },
          ],
        },
        howManyTravellers: {
          title: "Combien de voyageurs ?",
          content:
            "Tous nos hébergements offrent des lits confortables, un éclairage d'ambiance et une touche de technologie. Comment préférez-vous séjourner ? <ul className=\"list-disc p-4\"><li>Vous voyagez en solo ou en couple et voulez de l'intimité ? → Optez pour un Hub.</li><li>Vous restez ensemble mais préférez des lits séparés ? → Un Twin Hub est parfait.</li></ul>Quel que soit votre choix, vous dormirez à merveille.<br />Sélectionnez 1 ou 2 personnes pour voir les tarifs.",
        },
        addAnotherAccomodation: {
          title: "Ajouter un autre hébergement",
          hub: {
            title: "Hub",
            description:
              "Hub privé avec lit king-size – parfait pour un ou deux voyageurs. ",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Hub privé avec deux lits simples et une cloison – idéal pour les amis.",
          },
        },
      },
      tags: {
        hub: [
          "Hub privé pour 1-2 personnes ",
          "1 lit king-size",
          "Salles de bain partagées",
          "Produits Rituals",
          "Serviettes",
          "Kimonos",
        ],
        twinHub: [
          "Hub privé pour 2 personnes ",
          "2 matelas simples avec cloison",
          "Salles de bain partagées",
          "Produits Rituals",
          "Serviettes",
          "Kimonos",
        ],
        room: [
          "Chambre de 20 m² pour 1-4 personnes",
          "4 lits superposés ou lit double & 2 superposés",
          "Salle de bain privée",
          "Produits Rituals",
          "Serviettes",
          "Kimonos",
          "Accès PMR",
        ],
        movieHub: [
          "Hub privé pour 1-2 personnes ",
          "1 lit king-size",
          "Salles de bain partagées",
          "Produits Rituals",
          "Serviettes",
          "Kimonos",
          "Télévision",
        ],
      },
      faq: {
        hub: [
          {
            q: "Hub supérieur ou inférieur ? Puis-je choisir ? ",
            a: "Oui. Un Hub est votre propre pod privé en forme de L, conçu pour deux personnes. Les Hubs sont conçus par paires, un en haut et un en bas. Au check-in, vous choisissez si vous préférez prendre de la hauteur ou rester au niveau du sol. ",
          },
          {
            q: "En savoir plus sur le Hub ",
            a: "Votre Hub de 6 m² offre des espaces de rangement intelligents, des prises électriques et le WiFi. Le lit est préparé pour votre arrivée. Avec l'application CityHub, adaptez l'éclairage à votre humeur et profitez du streaming musical via Bluetooth. ",
          },
          {
            q: "Y a-t-il la climatisation dans le Hub ? ",
            a: "Oui, le Hub bénéficie d'une climatisation centrale réglée pour un confort optimal. ",
          },
          {
            q: "Comment sont les salles de bain ? ",
            a: "Plutôt luxueuses. Partagées mais séparées pour hommes et femmes, elles sont équipées de douches à effet pluie et de produits de toilette inclus. Elles restent impeccables toute la journée, tous les jours. ",
          },
          {
            q: "Avez-vous des serviettes ? Que dois-je apporter ? ",
            a: "Tout est fourni : serviettes, savon et shampoing Rituals, sèche-cheveux… et oui, un fer à repasser ! Nous avons même des kimonos CityHub pour aller confortablement à la douche. N'oubliez pas vos tongs, par contre. ",
          },
          {
            q: "Puis-je venir avec des enfants ? ",
            a: "Nous adorons les enfants ! Malheureusement, nos espaces communs ne sont pas adaptés aux bébés et aux enfants de moins de 6 ans. Chaque Hub peut accueillir jusqu'à 2 personnes, enfants compris. ",
          },
        ],
        twinHub: [
          {
            q: "Hub supérieur ou inférieur ? Puis-je choisir ? ",
            a: "Oui. Un Hub est votre propre pod privé en forme de L, conçu pour deux personnes. Les Hubs sont conçus par paires, un en haut et un en bas. Au check-in, vous choisissez avec votre CityHost si vous préférez monter ou rester en bas. ",
          },
          {
            q: "En savoir plus sur le Hub ",
            a: "Votre Hub de 6 m² offre des espaces de rangement intelligents, des prises électriques et le WiFi. Le lit est préparé pour votre arrivée. Avec l'application CityHub, adaptez l'éclairage à votre humeur. Streaming musical via Bluetooth inclus. ",
          },
          {
            q: "Y a-t-il la climatisation dans le Hub ? ",
            a: "Oui, le Hub bénéficie d'une climatisation centrale réglée pour un confort optimal. ",
          },
          {
            q: "Comment sont les salles de bain ? ",
            a: "Plutôt luxueuses. Partagées mais séparées pour hommes et femmes, elles sont équipées de douches à effet pluie et de produits de toilette inclus. Elles restent impeccables toute la journée, tous les jours. ",
          },
          {
            q: "Avez-vous des serviettes ? Que dois-je apporter ? ",
            a: "Tout est fourni : serviettes, savon et shampoing Rituals, sèche-cheveux… et oui, un fer à repasser ! Nous avons même des kimonos CityHub pour aller confortablement à la douche. N'oubliez pas vos tongs, par contre. ",
          },
          {
            q: "Puis-je venir avec des enfants ? ",
            a: "Nous adorons les enfants ! Malheureusement, nos espaces communs ne sont pas adaptés aux bébés et aux enfants de moins de 6 ans. Chaque Hub peut accueillir jusqu'à 2 personnes, enfants compris. ",
          },
        ],
        room: [
          {
            q: "En savoir plus sur la Quad Room ",
            a: "Votre Quad Room dispose d'une salle de bain privée et est équipée de prises et du WiFi. Les lits sont faits. Avec l'application CityHub, adaptez l'éclairage à votre humeur. Streaming musical via Bluetooth inclus.",
          },
          {
            q: "Y a-t-il la climatisation dans la Quad Room ? ",
            a: "Oui, votre Quad Room bénéficie d'une climatisation centrale réglée pour un confort optimal.",
          },
          {
            q: "Avez-vous des serviettes ? Que dois-je apporter ? ",
            a: "Tout est fourni : serviettes, produits Rituals, sèche-cheveux et fer à repasser. Nous avons aussi des kimonos CityHub. N'oubliez pas vos tongs ! ",
          },
          {
            q: "Puis-je venir avec des enfants ? ",
            a: "Nous adorons les enfants ! Malheureusement, nos espaces communs ne sont pas adaptés aux bébés et aux enfants de moins de 6 ans. Une Quad Room accueille 4 personnes max. ",
          },
        ],
        movieHub: [
          {
            q: "En savoir plus sur le Movie Hub ",
            a: "Votre Movie Hub offre des rangements malins, le WiFi et un grand écran TV. Le lit est prêt. Avec l'application CityHub, adaptez l'éclairage à votre humeur. Streaming musical via Bluetooth inclus. ",
          },
          {
            q: "Y a-t-il la climatisation dans le Movie Hub ? ",
            a: "Oui, le Movie Hub bénéficie d'une climatisation centrale réglée pour un confort optimal. ",
          },
          {
            q: "Comment sont les salles de bain ? ",
            a: "Plutôt luxueuses. Partagées mais séparées, avec douches à effet pluie et produits de toilette offerts. Elles restent propres toute la journée. ",
          },
          {
            q: "Avez-vous des serviettes ? Que dois-je apporter ? ",
            a: "Tout est fourni : serviettes, produits Rituals et kimonos CityHub. N'oubliez pas vos tongs. ",
          },
          {
            q: "Puis-je venir avec des enfants ? ",
            a: "Nous aimons les enfants, vraiment. Malheureusement, nos espaces communs ne sont pas adaptés aux bébés ou aux très jeunes enfants de moins de 6 ans. Veuillez noter qu'une chambre Quad peut accueillir un maximum de 4 personnes, enfants compris ",
          },
        ],
      },
    },
    modal: {
      selectHotel: {
        title: "Choisir une ville",
        button: { label: "Choisir la ville" },
      },
      selectCulture: {
        title: "Langue & devise",
        button: { label: "Enregistrer les modifications" },
      },
      uspBar: {
        title: "Meilleur prix garanti",
        content:
          "Nous garantissons le meilleur prix pour toute réservation effectuée sur ce site.",
      },
    },
    component: {
      uspBar: {
        title: "Meilleur prix garanti",
      },
    },
    scenes: {
      traveller_one: "voyageur",
      traveller_other: "voyageurs",
      night_one: "nuit",
      night_other: "nuits",
      selectHotel: {
        chooseCity: "Choisissez votre ville pour réserver.",
      },
      accommodation: {
        pricePerNight: "Prix par nuit",
        pricePerNightInclVat: "Prix par nuit (TVA incluse)",
        remove: "Supprimer",
        directBookingDiscount: "Remise réservation directe",
        notAvailable: "non disponible",
        unavailable: "Indisponible",
        noMoreRoomsAvailable: "Réservez vite · dernier Hub",
        addAnotherRoom: "Ajouter une chambre",
        addAnotherHub: "Ajouter un Hub",
        howManyTravellers: "Combien de voyageurs ?",
        questions: "FAQs ",
        moreTags_one: "tag supplémentaire",
        moreTags_other: "tags supplémentaires",
        more_info: "Plus d'infos",
        not_available: "Non disponible à cette date",
        show_more: "Plus d'informations",
        show_less: "Moins d'informations",
        selected: "sélectionné",
      },
      calendar: {
        startNotice: "{{hotelName}} ouvre ses portes le {{startDate}}",
      },
      extras: {
        perPersonPerNight: "par personne, par nuit",
        add: "Ajouter",
        remove: "Supprimer",
        moreInfo: "Plus d'infos",
      },
      summary: {
        perNight: "/ nuit",
        checkIn: "CHECK-IN",
        checkOut: "CHECK-OUT",
        rate: "Tarif :",
        discount: "Remise :",
        from: "À partir de",
        before: "Avant",
        total: "Total",
        incCityTax: "Taxes de séjour",
        incVat: "TVA incluse",
        incVatRooms: "TVA chambres incluse",
        incVatProducts: "TVA produits incluse",
        directBookingDiscount: "Remise réservation directe",
        voucher: "Code promo",
        addVoucher: "Ajouter un Code promo",
        voucherInvalid: "Ce code n'est pas valide",
        voucherNotApplicable: "Ce code promo n'est pas valable pour le tarif sélectionné",
      },
      details: {
        firstName: "Prénom",
        firstNameRequired: "Le prénom est requis",
        lastName: "Nom",
        lastNameRequired: "Le nom est requis",
        email: "Adresse e-mail",
        emailRequired: "L'e-mail est requis",
        emailInvalid: "E-mail invalide (doit contenir un @ et un point)",
        phoneMin: "Le téléphone doit contenir au moins 9 chiffres",
        phoneInvalid: "Le téléphone doit être numérique",
        countryRequired: "Le pays est requis",
        phone: "Numéro de téléphone",
        country: "Pays",
        selectCountry: "Sélectionnez votre pays",
        specialRequests: "Demandes spéciales",
        terms:
          "J'accepte les <firstLink>CGV</firstLink> et la <secondLink>Politique de confidentialité</secondLink>.",
        marketingEmails: "Je souhaite recevoir des actualités marketing.",
        createReservation: "Créer la réservation",
        finishPaymentAtKiosk: "Finalisez votre paiement à notre borne.",
        creatingReservation: "Création de votre réservation...",
        reservationCreated: "Réservation créée !",
        somethingWentWrong: "Une erreur est survenue, veuillez réessayer.",
      },
      payment: {
        paymentMethods: "Modes de paiement",
        paymentMethodsDescription:
          "Dernière étape. Finalisez votre paiement en toute sécurité. Nous utilisons des méthodes chiffrées pour protéger vos données. Une confirmation vous sera envoyée par e-mail.",
        authorizeCreditCard: "Autoriser votre carte",
        cardChargeInfo: "Votre carte sera débitée 48 h avant l'arrivée",
        securedWithMews: "Sécurisé par Mews Payments via PCI Proxy",
        payWithCreditCard: "Payer par carte de crédit",
        payDirectly: "Payer directement",
        onlyVisaAndMastercardSupported:
          "Seules Visa et MasterCard sont acceptées",
        nameOnCreditCard: "Nom sur la carte",
        cardNumber: "Numéro de carte",
        expirationDate: "Date d'expiration",
        expirationDateRequired: "La date d'expiration est requise",
        yearCanNotBeInThePast: "L'année ne peut pas être passée",
        yearCanNotBeMoreThan5YearsInTheFuture: "Max 5 ans dans le futur",
        monthCanNotBeInThePast: "Le mois ne peut pas être passé",
        monthCanNotBeBiggerThan12: "Mois invalide",
        shouldBeAMonthAndAYear: "Format MM/AAAA",
        validateCard: "Valider la carte",
        createReservation: "Créer la réservation",
        nameIsRequired: "Le nom est requis",
        cardNumberIsRequired: "Le numéro de carte est requis",
        invalidCardNumber: "Numéro de carte invalide",
        cvcIsRequired: "Le CVC est requis",
        invalidCvc: "CVC invalide",
        somethingWentWrong: "Une erreur est survenue. Réessayez plus tard.",
        somethingWentWrong4501: "Erreur (4501). Réessayez plus tard.",
        creatingReservation: "Création de votre réservation...",
        reservationCreated: "Réservation créée !",
        finishPayment: "Finalisation du paiement...",
        creditcardNotAuthorizable: "Carte non autorisable",
      },
      success: {
        bookingConfirmed: "Réservation confirmée !",
        bookingConfirmedDescription:
          "Votre séjour au {{hotelName}} est prêt. <br/>Check-in à partir de 15h. À bientôt 👋",
        startChatting: "Commencer à discuter",
        viewBookingDetails: "Détails de la réservation",
        bookingDetails: "Détails de la réservation",
        whatsNext: "Et ensuite ?",
        connectWithHost:
          "Contactez votre CityHost, votre contact personnel 24/7 pour des conseils et des secrets locaux.",
        online: "EN LIGNE",
      },
      pageNotFound: {
        message: "Oups ! <br />Page introuvable.",
        linkText: "Choisissez votre hôtel pour commencer",
      },
      redirectHotel: {
        message: "Chargement de la configuration...",
      },
      redirectPayment: {
        error4602: "[erreur" + ":4602] Réservation introuvable",
        noPaymentsFound: "Aucun paiement trouvé",
        paymentSuccessful: "Paiement réussi",
        paymentFailed: "Le paiement a échoué",
        returningToSite: "Retour au site...",
        authorizationPending: "Autorisation en attente",
        authorizationPendingMessage:
          "Votre réservation a été créée, mais l'autorisation est toujours en attente.Cliquez ici pour autoriser votre carte.",
      },
    },
    form: {
      language: {
        label: "Langue",
        placeholder: "Choisir la langue",
        options: {
          "en-US": "Anglais",
          "nl-NL": "Néerlandais",
          "de-DE": "Allemand",
          "fr-FR": "Français",
        },
        validation: { required: "La langue est requise" },
      },
      currency: {
        label: "Devise",
        placeholder: "Choisir la devise",
        options: {
          EUR: "Euro (€)",
          USD: "Dollar US ($)",
          GBP: "Livre Sterling (£)",
          CAD: "Dollar Canadien (C$)",
          DKK: "Couronne Danoise (DKK)",
          ISK: "Couronne Islandaise (ISK)",
        },
        validation: { required: "La devise est requise" },
      },
    },
  },
};
